<template>
  <v-row>
    <v-col
      cols="9"
      md="9"
    >
      <v-data-table-server
        v-model:options="options"
        dense
        fixed-header
        :headers="headers"
        :loading="loading"
        :items="items"
        :items-length="totalItems"
        class="elevation-1 lead-queue-table"
        :items-per-page-options="footerProps.itemsPerPageOptions"
        @update:options="updateTable"
      >
        <template #top>
          <v-card-title>
            <v-toolbar flat>
              <v-toolbar-title>Lead Queue</v-toolbar-title>

              <v-spacer />

              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
                @input="searchTable()"
              />
            </v-toolbar>
          </v-card-title>
        </template>

        <template #item.autopay_added="{ item }">
          {{ item.autopay_added == 1 ? 'Yes' : 'No' }}
        </template>

        <template #item.docs_uploaded="{ item }">
          {{ item.docs_uploaded == 1 ? 'Yes' : 'No' }}
        </template>

        <template #item.activated="{ item }">
          {{ item.activated == 1 ? 'Yes' : 'No' }}
        </template>

        <template #item.created="{ item }">
          {{ formatDateTime(item.created) }}
        </template>

        <template #item.updated="{ item }">
          {{ formatDateTime(item.updated) }}
        </template>

        <template #item.actions="{ item }">
          <v-btn
            color="primary"
            small
            tile
            text
            :to="{ name: 'lead-queue-show', params: { id: item.lead_id } }"
          >
            <v-icon
              dark
              left
              class="mr-1"
            >
              mdi-eye
            </v-icon>
            VIEW
          </v-btn>
        </template>
      </v-data-table-server>
    </v-col>
    <v-col
      cols="3"
      md="3"
    >
      <BarGraph
        :data="loanproGraphData"
        title="Loanpro API"
        class="mb-4"
      />
      <BarGraph
        :data="pciwalletGraphData"
        title="PCI-wallet API"
      />
    </v-col>
  </v-row>
</template>

<script>
import { mapActions } from 'vuex';
import { DateTime } from 'luxon';
import BarGraph from '@/components/BarGraph.vue';
import dataTableMixin from '@/mixins/dataTableMixin.js';

export default {
  name: 'LeadAmortizationIndex',
  components: {
    BarGraph,
  },
  mixins: [
    dataTableMixin,
  ],
  data() {
    return {
      headers: [
        { title: 'Lead ID', value: 'lead_id' },
        { title: 'Customer ID', value: 'customer_id' },
        { title: 'Loan ID', value: 'loan_id' },
        { title: 'Autopay', value: 'autopay_added' },
        { title: 'Docs Uploaded', value: 'docs_uploaded' },
        { title: 'Loan Activated', value: 'activated' },
        { title: 'Created', value: 'created' },
        { title: 'Updated', value: 'updated' },
        { title: 'Actions', value: 'actions', sortable: false },
      ],
      loanproGraphData: [],
      pciwalletGraphData: [],
    };
  },
  created() {
    this.fetchQueueCount();
  },
  methods: {
    ...mapActions('sidebar', ['setQueueCount']),
    updateTable() {
      this.loading = true;
      return this.$axios
        .get('api/v1/lead-queue', {
          params: {
            perPage: this.options.itemsPerPage,
            page: this.options.page,
            ...this.sortParams,
            search: this.search,
          },
        })
        .then((res) => {
          this.loading = false;
          this.items = res.data.data;
          this.totalItems = res.data.total;

          this.fetchLoanproData();
          this.fetchPciData();
        });
    },
    fetchLoanproData() {
      return this.$axios
        .get('api/v1/lead-queue/loanpro-calls', {
          params: {
            search: this.search,
          },
        })
        .then((res) => {
          this.loanproGraphData = res.data;
        });
    },
    fetchPciData() {
      return this.$axios
        .get('api/v1/lead-queue/pci-calls', {
          params: {
            search: this.search,
          },
        })
        .then((res) => {
          this.pciwalletGraphData = res.data;
        });
    },
    fetchQueueCount() {
      return this.$axios
        .get('api/v1/lead-queue/count')
        .then((res) => {
          this.setQueueCount(res.data);
        });
    },
    formatDateTime(date) {
      return DateTime.fromISO(date).toUTC().toFormat('yyyy-MM-dd HH:mm:ss');
    },
  },
};
</script>

<style scoped>
.lead-queue-table {
  overflow-x: auto;
}

.lead-queue-table :deep(th) {
  white-space: nowrap;
}

.lead-queue-table :deep(td) {
  white-space: nowrap;
}
</style>
